import { Dayjs } from 'dayjs';
import React from 'react';
import { useGetDailyLineHaulSummary } from '../../../../hooks/useGetDailyPickupsSummary';
import { ProgressBar } from '../ProgressBar/ProgressBar';
import './ScansTotalRemaining.scss';
import { ParcelsLineHaulCount } from '../../../../types/statsTypes';
export function ScansTotalRemaining({
  parcelsLineHaulSummary,
}: {
  parcelsLineHaulSummary: ParcelsLineHaulCount[];
}): JSX.Element {
  const totalLineHaulParcelsScansToDoForDate: number =
    parcelsLineHaulSummary &&
    parcelsLineHaulSummary.length &&
    parcelsLineHaulSummary
      .map(obj => obj.lineHaulParcelsScansToDoForDate)
      .reduce((a, b) => a + b);

  const totalLineHaulParcelsScansDoneForDate: number =
    parcelsLineHaulSummary &&
    parcelsLineHaulSummary.length &&
    parcelsLineHaulSummary
      .map(obj => obj.lineHaulParcelsScansDoneForDate)
      .reduce((a, b) => a + b);
  return (
    <div className="ScansTotalRemainingDiv">
      <div className="positionText">
        <div className="title">{'SCANS REMAINING'}</div>
        <div className="stats">
          <ProgressBar
            done={totalLineHaulParcelsScansDoneForDate}
            total={totalLineHaulParcelsScansToDoForDate}
          />
        </div>
      </div>
    </div>
  );
}

export function ScansTotalRemainingComponent({
  forDate,
}: {
  forDate: Dayjs;
}): JSX.Element {
  const { parcelsLineHaulSummary, lineHaulSummaryLoading } =
    useGetDailyLineHaulSummary(forDate);

  if (lineHaulSummaryLoading === true) {
    return (
      <>
        <ScansTotalRemaining parcelsLineHaulSummary={[]} />
      </>
    );
  } else if (lineHaulSummaryLoading === false) {
    return (
      <>
        <ScansTotalRemaining parcelsLineHaulSummary={parcelsLineHaulSummary} />
      </>
    );
  }
}
